<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 134.971 51">
    <g id="Convertible" transform="translate(10739.472 949.182)">
      <path id="Path_87088" data-name="Path 87088"
        d="M46.239,10.338A10.737,10.737,0,1,0,56.976,21.075,10.75,10.75,0,0,0,46.239,10.338m0,18.826a8.089,8.089,0,1,1,8.089-8.089,8.1,8.1,0,0,1-8.089,8.089"
        transform="translate(-10673.616 -929.994)" :fill="themeColor" />
      <path id="Path_87089" data-name="Path 87089"
        d="M17.094,10.338A10.737,10.737,0,1,0,27.831,21.075,10.75,10.75,0,0,0,17.094,10.338m0,18.826a8.089,8.089,0,1,1,8.089-8.089,8.1,8.1,0,0,1-8.089,8.089"
        transform="translate(-10727.718 -929.994)" :fill="themeColor" />
      <path id="Path_87090" data-name="Path 87090"
        d="M63.972,16.983a1.345,1.345,0,0,0,1.414-1.28A1.329,1.329,0,0,0,64.1,14.335l-.02,0,.069-1.425-.109,1.425-46.426,0a1.394,1.394,0,0,0-1.414,1.28,1.322,1.322,0,0,0,1.282,1.368Z"
        transform="translate(-10709.447 -925.225)" :fill="themeColor" />
      <path id="Path_87091" data-name="Path 87091"
        d="M133.461,40.944l.191,0a1.341,1.341,0,0,0,1.011-.451,1.314,1.314,0,0,0,.32-.96v-.006l-.009-.109c-.12-1.474-.446-5.124-.874-7.221-.074-.371-.294-1.485-3.687-3.385l-.334-.186-.194-.328a29.439,29.439,0,0,0-5.478-6.687c-2.982-2.082-10.745-3.316-21.371-4.816a102.954,102.954,0,0,1-14.267-2.579h-.254l-.366-.24C82.511,11.475,61.651.247,61.483.153A1.329,1.329,0,0,0,60.243,2.5C63,3.986,72.328,8.99,79.709,12.783l5.3,2.719-42.924-.166-8.34-4.253a1.33,1.33,0,0,0-.811-.129L7.159,15.14,3.117,13.349a1.312,1.312,0,0,0-.534-.114,1.324,1.324,0,0,0-.537,2.536L5.262,17.2.118,29.65a1.314,1.314,0,0,0-.069.8A12.7,12.7,0,0,0,10.224,40.947a1.4,1.4,0,0,0,1.02-.386,1.323,1.323,0,0,0-.783-2.256A10.089,10.089,0,0,1,2.84,30.652l-.094-.434L7.922,17.688l25-4.056,8.24,4.213a1.335,1.335,0,0,0,.6.146l51.048.194.734-.2.346.069c3.216.637,6.07,1.083,8.729,1.365,9.634,1.36,17.783,2.636,20.4,4.479a33.085,33.085,0,0,1,5.05,6.5,1.315,1.315,0,0,0,.486.434,17.786,17.786,0,0,1,2.516,1.6l.451.343.091.554c.357,2.077.646,5.333.726,6.412a1.336,1.336,0,0,0,1.12,1.211"
        transform="translate(-10739.488 -949.183)" :fill="themeColor" />
    </g>
  </svg>


</template>


<script>
import { mapWritableState } from 'pinia';
import { useChatSettingsStore } from '../../../../store/ChatSettingsStore/ChatSettingsStore';

export default {
  props: {
    themeColor: {
      type: String,
      required: false,
      default: '#B3B3B3',
    },
    isHoverUser: {
      type: Boolean,
      required: false,
      default: false,
    },
    height: {
      type: String,
      required: false,
      default: '50px',
    },
    width: {
      type: String,
      required: false,
      default: '100px',
    },
  },
  data() {
    return {
      themePrimaryColor: window.primaryColor,
    }
  },
  computed: {
    ...mapWritableState(useChatSettingsStore, ['chatThemeSettings']),
    isGradient() {
      return this.chatThemeSettings?.isGradient || false;
    },
  },
  mounted() {
    if (this.chatThemeSettings?.primeColor) {
      this.themePrimaryColor = this.chatThemeSettings.primeColor;
    }
  },
}
</script>
